<template>
  <div class="fs-adjustments">
    <fs-range-filter-wrapper min="0" max="1" :routerLink="'/adjustments'" v-model="value.blur" label="menu.blur"/>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import { Adjustments } from '@filestack/canvas-sdk';

import { FilterMixin } from './FilterMixin';

@Component
class Blur extends FilterMixin {
  protected filter = new Adjustments.Blur();

  protected value = { blur: 0 };
}

export default Blur;

</script>
